import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EmissionsData } from 'brain-data/model/emissions.model';
import { FACILITY_GROUPS_URL } from '../facility-group/facility-group.service';
import { FACILITIES_URL } from '../facility/facility.service';

export const EMISSIONS_URL = `${environment.apiBaseUrl}/emissions`;

@Injectable({
  providedIn: 'root',
})
export class EmissionsService {
  constructor(private http: HttpClient) {}

  getEmissionsForCity(startDate: string, endDate: string): Observable<EmissionsData> {
    const params = new HttpParams({ fromObject: { from: startDate, to: endDate } });
    return this.http.get<EmissionsData>(`${EMISSIONS_URL}`, { params });
  }

  getEmissionsForGroup(facilityGroupId: number, startDate: string, endDate: string): Observable<EmissionsData> {
    const params = new HttpParams({ fromObject: { from: startDate, to: endDate } });
    return this.http.get<EmissionsData>(`${FACILITY_GROUPS_URL}/${facilityGroupId}/emissions`, { params });
  }

  getEmissionsForFacility(facilityId: number, startDate: string, endDate: string): Observable<EmissionsData> {
    const params = new HttpParams({ fromObject: { from: startDate, to: endDate } });
    return this.http.get<EmissionsData>(`${FACILITIES_URL}/${facilityId}/emissions`, { params });
  }

  getEmissionsForFacilityContract(facilityId: number, contractNumber: string, startDate: string, endDate: string): Observable<EmissionsData> {
    const params = new HttpParams({ fromObject: { from: startDate, to: endDate } });
    return this.http.get<EmissionsData>(`${FACILITIES_URL}/${facilityId}/utilityContracts/${contractNumber}/emissions`, { params });
  }
}
